import Vue from "vue";
import axios, { AxiosInstance, AxiosRequestConfig } from "axios";

export interface AxiosRequestConfigDef extends AxiosRequestConfig {
  progress?: boolean;
  skipAuthRefresh?: boolean;
}

export const EventBus = new Vue();

/**
 * Init full loading spinner on selected axios instance
 * can set later axiosconfig.progress on each call to enable/disable it
 * @param config
 * @param instance
 */
export function initFullLoading(
  config: AxiosRequestConfigDef,
  instance: AxiosInstance = axios
) {
  let requestsCounter = 0;

  const setupStartProgress = () => {
    instance.interceptors.request.use((config: any) => {
      if (config && config.progress === false) {
        //progress bar is disabled for this request
      } else {
        requestsCounter++;
        if (requestsCounter === 1) {
          EventBus.$emit("show-my-full-loading");
        }
      }
      return config;
    });
  };

  const setupStopProgress = () => {
    const responseFunc = (response: any) => {
      if (
        (!response ||
          !response.config ||
          !(response.config.progress === false)) &&
        --requestsCounter === 0
      ) {
        EventBus.$emit("hide-my-full-loading");
      }
      return response;
    };

    const errorFunc = (error: any) => {
      if (
        (!error || !error.config || !(error.config.progress === false)) &&
        --requestsCounter === 0
      ) {
        EventBus.$emit("hide-my-full-loading");
      }
      if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        if (
          error.response.data &&
          error.response.data.code &&
          error.response.data.code !== ""
        ) {
          console.error(
            "Response failed with managed backend:",
            error.response.status,
            error.response.data
          );
        } else {
          console.error(
            "Response failed with message:",
            error.message,
            error.response
          );
        }
      } else if (error.request) {
        // The request was made but no response was received
        // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
        // http.ClientRequest in node.js
        console.error(
          "Request failed without response:",
          error.message,
          error.request
        );
      } else {
        // Something happened in setting up the request that triggered an Error
        console.error("Request setup error with message:", error.message);
      }
      return Promise.reject(error);
    };

    instance.interceptors.response.use(responseFunc, errorFunc);
  };

  setupStartProgress();
  setupStopProgress();
}
